module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftbar-view elffy-dashboard",
    class: {
      'left-aside-toggle': _vm.toggle_aside
    }
  }, [_c('section', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('smallBar')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "material-table1-widget dashboard_top_bar"
  }, [_c('button', {
    staticClass: "btn btn-default btn-new",
    on: {
      "click": function($event) {
        _vm.newFixMoneyModal = true;
        _vm.temp_fix_money.money_type = 'income'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 建立固定收入")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-new",
    on: {
      "click": function($event) {
        _vm.newFixMoneyModal = true;
        _vm.temp_fix_money.money_type = 'expend'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  }), _vm._v(" 建立固定支出")])]), _vm._v(" "), _c('div', {
    staticClass: "widget-wrap"
  }, [_c('div', {
    staticClass: "block-header  clearfix"
  }, [_c('div', {
    staticClass: "btn-group pull-left",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "role": "group",
      "aria-label": "..."
    }
  }, [_c('button', {
    staticClass: "btn btn-default relative",
    class: {
      'active': _vm.now_at == 'income_active'
    },
    on: {
      "click": function($event) {
        _vm.now_at = 'income_active'
      }
    }
  }, [_vm._v("\n\t\t\t\t          \t固定收入(" + _vm._s(_vm.filteFixMoneyByType('income', 'active').length) + ")\n\t\t\t\t          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    class: {
      'active': _vm.now_at == 'income_history'
    },
    on: {
      "click": function($event) {
        _vm.now_at = 'income_history'
      }
    }
  }, [_vm._v("\n\t\t\t\t          \t歷史(" + _vm._s(_vm.filteFixMoneyByType('income', 'history').length) + ")\n\t\t\t\t          ")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group pull-left",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "role": "group",
      "aria-label": "..."
    }
  }, [_c('button', {
    staticClass: "btn btn-default relative",
    class: {
      'active': _vm.now_at == 'expend_active'
    },
    on: {
      "click": function($event) {
        _vm.now_at = 'expend_active'
      }
    }
  }, [_vm._v("\n\t\t\t\t          \t固定支出(" + _vm._s(_vm.filteFixMoneyByType('expend', 'active').length) + ")\n\t\t\t\t          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    class: {
      'active': _vm.now_at == 'expend_history'
    },
    on: {
      "click": function($event) {
        _vm.now_at = 'expend_history'
      }
    }
  }, [_vm._v("\n\t\t\t\t          \t歷史(" + _vm._s(_vm.filteFixMoneyByType('paid', 'history').length) + ")\n\t\t\t\t          ")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.filtedFixMoney()), function(fix_money) {
    return _c('tr', {
      staticClass: "text-left"
    }, [_c('td', [_vm._v(_vm._s(fix_money.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fix_money.money_category_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getPeriodType(fix_money)))]), _vm._v(" "), _c('td', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getPeriod(fix_money))
      }
    })]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(fix_money.amount.toLocaleString()) + "元")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-xs btn-success",
      on: {
        "click": function($event) {
          _vm.showMoneys(fix_money)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-list"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs btn-warning",
      on: {
        "click": function($event) {
          _vm.temp_fix_money = fix_money;
          _vm.newFixMoneyModal = true
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-pencil-alt"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs btn-danger",
      on: {
        "click": function($event) {
          _vm.temp_fix_money = fix_money;
          _vm.deleteFixMoneyModal = true
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  })], 2)])])])])]), _vm._v(" "), (_vm.newFixMoneyModal) ? _c('div', [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.newFixMoneyModal = false;
        _vm.resetTempFixMoney()
      }
    }
  }, [_c('div', {
    staticClass: "modal-container modal-center col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.newFixMoneyModal = false;
        _vm.resetTempFixMoney()
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body j-forms",
    staticStyle: {
      "overflow": "initial"
    }
  }, [_c('div', [_c('div', {
    staticClass: "form"
  }, [(_vm.temp_fix_money.id == '' && _vm.temp_fix_money.money_type == 'income') ? _c('h4', [_vm._v("\n                  \t建立固定收入之後，會自動產生應收項目\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.temp_fix_money.id == '' && _vm.temp_fix_money.money_type == 'expend') ? _c('h4', [_vm._v("\n                  \t建立固定支出之後，會自動產生應付項目\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.temp_fix_money.id != '') ? _c('h4', [_vm._v("\n                  \t編輯 " + _vm._s(_vm.temp_fix_money.name) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.temp_fix_money.id == '') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("項目名稱*：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_fix_money.name),
      expression: "temp_fix_money.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "項目名稱",
      "name": "title"
    },
    domProps: {
      "value": (_vm.temp_fix_money.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.temp_fix_money.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('title')),
      expression: "errors.has('title')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("請輸入名稱")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("項目分類*：")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_fix_money.money_category_id),
      expression: "temp_fix_money.money_category_id"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "13px !important"
    },
    attrs: {
      "name": "money_category_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.temp_fix_money.money_category_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("請選擇")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return (category.money_type == _vm.temp_fix_money.money_type) ? _c('option', {
      domProps: {
        "selected": _vm.temp_fix_money.money_category_id == category.id,
        "value": category.id
      }
    }, [_vm._v(_vm._s(category.name))]) : _vm._e()
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('money_category_id')),
      expression: "errors.has('money_category_id')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("請選擇")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("金額*：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_fix_money.amount),
      expression: "temp_fix_money.amount"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "金額",
      "name": "amount"
    },
    domProps: {
      "value": (_vm.temp_fix_money.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.temp_fix_money.amount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('amount')),
      expression: "errors.has('amount')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("請輸入金額")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("週期*：")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_fix_money.period_type),
      expression: "temp_fix_money.period_type"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "13px !important"
    },
    attrs: {
      "name": "money_category_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.temp_fix_money.period_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "year"
    }
  }, [_vm._v("每年")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "month"
    }
  }, [_vm._v("每月")])])]), _vm._v(" "), (_vm.temp_fix_money.period_type == 'year') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_fix_money.period_month),
      expression: "temp_fix_money.period_month"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "13px !important"
    },
    attrs: {
      "name": "period_month"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.temp_fix_money.period_month = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("請選擇月份")]), _vm._v(" "), _vm._l((_vm.months), function(month) {
    return _c('option', {
      domProps: {
        "value": month
      }
    }, [_vm._v(_vm._s(month) + "月")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('period_month')),
      expression: "errors.has('period_month')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("請選擇")])]) : _vm._e(), _vm._v(" "), (_vm.temp_fix_money.period_type == 'year' || _vm.temp_fix_money.period_type == 'month') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_fix_money.period_day),
      expression: "temp_fix_money.period_day"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "13px !important"
    },
    attrs: {
      "name": "period_day"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.temp_fix_money.period_day = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("請選擇日")]), _vm._v(" "), _vm._l((_vm.days), function(day) {
    return _c('option', {
      domProps: {
        "value": day
      }
    }, [_vm._v(_vm._s(day) + "日")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('period_day')),
      expression: "errors.has('period_day')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("請選擇")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("發票*：")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_fix_money.invoice_status),
      expression: "temp_fix_money.invoice_status"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "13px !important"
    },
    attrs: {
      "name": "invoice_status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.temp_fix_money.invoice_status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "not_create"
    }
  }, [_vm._v("要發票")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "no_invoice"
    }
  }, [_vm._v("不要發票")])])])])]) : _c('div'), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.temp_fix_money.has_date_range == false) ? _c('p', {
    staticClass: "pointer text-primary",
    on: {
      "click": function($event) {
        _vm.temp_fix_money.has_date_range = true
      }
    }
  }, [_vm._v("點擊可設定起始與結束日期")]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("起始日期")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "clear-button": true,
      "clear-button-icon": "fa fa-times",
      "input-class": "form-control",
      "format": _vm.customFormatter,
      "language": "zh"
    },
    model: {
      value: (_vm.temp_fix_money.start_at),
      callback: function($$v) {
        _vm.temp_fix_money.start_at = $$v
      },
      expression: "temp_fix_money.start_at"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("結束日期")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "clear-button": true,
      "clear-button-icon": "fa fa-times",
      "input-class": "form-control",
      "format": _vm.customFormatter,
      "language": "zh"
    },
    model: {
      value: (_vm.temp_fix_money.end_at),
      callback: function($$v) {
        _vm.temp_fix_money.end_at = $$v
      },
      expression: "temp_fix_money.end_at"
    }
  })], 1)]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.temp_fix_money.loading == false) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.submitTempFixMoney()
      }
    }
  }, [_vm._v("送出")]) : _c('button', {
    staticClass: "btn btn-success disabled",
    attrs: {
      "type": "button",
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin "
  }), _vm._v(" 送出中\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.newFixMoneyModal = false;
        _vm.resetTempFixMoney()
      }
    }
  }, [_vm._v("取消")])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showFinanceMoneyModal) ? _c('div', [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.showFinanceMoneyModal = false;
        _vm.resetTempFixMoney()
      }
    }
  }, [_c('div', {
    staticClass: "modal-container modal-center col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showFinanceMoneyModal = false;
        _vm.resetTempFixMoney()
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body j-forms"
  }, [_c('div', [_c('div', {
    staticClass: "form"
  }, [_c('h4', [_vm._v("\n                  \t" + _vm._s(_vm.temp_fix_money.name) + "\n                  ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(3), _vm._v(" "), _vm._l((_vm.temp_fix_money.finance_moneys), function(m) {
    return _c('tr', [_c('td', {
      domProps: {
        "innerHTML": _vm._s(m.date)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(m.finish_at)
      }
    }), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(m.title))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.money_category_name))]), _vm._v(" "), _c('td', [_c('b', [_vm._v("NT$ " + _vm._s(m.amount.toLocaleString()))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.showFinanceMoneyModal = false;
        _vm.resetTempFixMoney()
      }
    }
  }, [_vm._v("關閉")])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.deleteFixMoneyModal) ? _c('div', [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.deleteFixMoneyModal = false;
        _vm.resetTempFixMoney()
      }
    }
  }, [_c('div', {
    staticClass: "modal-container modal-center col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('h4', [_vm._v("\n                  \t刪除 " + _vm._s(_vm.temp_fix_money.name) + "\n                  ")]), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.deleteFixMoneyModal = false;
        _vm.resetTempFixMoney()
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body j-forms"
  }, [_c('div', [_c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 text-center"
  }, [(_vm.temp_fix_money.loading == false) ? _c('button', {
    staticClass: "btn btn-default mb-3",
    on: {
      "click": function($event) {
        _vm.deleteFixMoney('only_fix_money')
      }
    }
  }, [_vm._v("僅刪除固定支出")]) : _c('button', {
    staticClass: "btn btn-default mb-3"
  }, [_vm._v("刪除中...")]), _vm._v(" "), _c('p', [_vm._v("將會刪除此固定收支，但保留已建立的收支項目")]), _vm._v(" "), _c('p', [_vm._v("你也可以使用『編輯->變更到期日』的方式，到期的項目將會進入歷史")]), _vm._v(" "), _c('p', [_vm._v("刪除的固定收支不會進入歷史")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-center"
  }, [(_vm.temp_fix_money.loading == false) ? _c('button', {
    staticClass: "btn btn-danger mb-3",
    on: {
      "click": function($event) {
        _vm.deleteFixMoney('all')
      }
    }
  }, [_vm._v("刪除固定支出與收支項目" + _vm._s(_vm.temp_fix_money.finance_moneys.length) + "筆")]) : _c('button', {
    staticClass: "btn btn-danger mb-3"
  }, [_vm._v("刪除中...")]), _vm._v(" "), _c('p', {
    staticClass: "text-danger"
  }, [_vm._v("將會永久刪除此固定收支，以及底下的收支項目")])])])])])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mt-3"
  }, [_vm._v("固定收支建立之後，將會自動產生該應收應付項目，你可以在收支管理查看，或點擊右側的 "), _c('button', {
    staticClass: "btn btn-success btn-xs"
  }, [_c('i', {
    staticClass: "fa fa-list"
  })]), _vm._v(" 查看屬於該項目的明細")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "col-md-2"
  }, [_vm._v("項目名稱")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2"
  }, [_vm._v("分類")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2"
  }, [_vm._v("週期")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2"
  }, [_vm._v("起訖時間")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2"
  }, [_vm._v("金額")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "text-gray"
  }, [_vm._v("如果有填寫起始與初始日期，則會直接建立這週期內的應收款項，如果沒有填寫結束日期，則會依照年度到了才建立整年應收款項")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("應收日期")]), _vm._v(" "), _c('th', [_vm._v("實收日期")]), _vm._v(" "), _c('th', [_vm._v("名稱")]), _vm._v(" "), _c('th', [_vm._v("分類")]), _vm._v(" "), _c('th', [_vm._v("金額")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0985fb26","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Finances/FixedMoney.vue
// module id = 664
// module chunks = 4